let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("UE0Lj")).then(() => parcelRequire('bpOU2'));